/**
 * Tipos e schemas compartilhados pra área do trader (Marco 4).
 * Os valores em "*Cents" são sempre inteiros (BRL ou USD); o frontend
 * formata. Datas trafegam como ISO 8601 strings.
 */
import { z } from 'zod';
export function withdrawalBreakdown(grossCents) {
    const mesaFeeCents = Math.round(grossCents * 0.2);
    const irCents = Math.round(grossCents * 0.2);
    return { grossCents, mesaFeeCents, irCents, netCents: grossCents - mesaFeeCents - irCents };
}
export const equityCurveQuerySchema = z.object({
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
});
export const calendarQuerySchema = z.object({
    year: z.coerce.number().int().min(2020).max(2100),
    month: z.coerce.number().int().min(1).max(12),
});
export const dailySummaryQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(10),
});
export const tradesQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(50),
    from: z.string().date().optional(),
    to: z.string().date().optional(),
    symbol: z.string().optional(),
    side: z.enum(['BUY', 'SELL']).optional(),
});
export const requestWithdrawalSchema = z.object({
    virtualAccountId: z.string().min(1),
    // coerce: a solicitação é enviada como multipart (carrega a nota fiscal), então
    // os campos chegam como string.
    amountCents: z.coerce.number().int().positive(),
    pixKey: z.string().min(1).max(140),
});
//# sourceMappingURL=trader.js.map